<!--
    描述：租户管理
    日期：2021/04/06
    作者：zwh
-->
<template>
	<div class="h100">
		<w-split class="h100"
				 v-model="splitValueL">
			<div class="w-page-main left"
				 slot="left">
				<div class="w-page-header">
					<div class="left-text overflow-hidden">
						<span><b>单位列表</b></span>
					</div>
					<div class="btnGroups ml10">
						<SearchArea ref="searchContent"
									v-model="unitName"
									placeholderName="单位名称"
									@on-search="onFilter"
									@on-refresh="onRefresh"
									:showMore="false">
						</SearchArea>
						<el-button type="primary"
								   size="small"
								   @click="addClick()"
								   class="ml10"
								   v-if="roleBtns.includes('tenant_add')">新增单位</el-button>
					</div>
				</div>
				<div class="w-page-container pdb10">
					<tenantTreeTable ref="tenantTreeTable"
									 @row-click="tenantRowClick"
									 @reset-select-tenant="tenantSelectReset"></tenantTreeTable>
				</div>
			</div>
			<div class="h100"
				 slot="right">
				<tenantUserTable ref="tenantUserTable"></tenantUserTable>
			</div>
		</w-split>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import wSplit from '@/components/split/split'
import wSplitRight from '@/components/split/split'
import tenantTreeTable from './components/tenant_tree_table'
import tenantUserTable from './components/tenant_user_table'
import subjectTree from './components/subject_tree'
import SearchArea from '@/components/searchArea/searchArea'
export default {
	name: '',
	components: {
		wSplit,
		wSplitRight,
		tenantTreeTable,
		tenantUserTable,
		subjectTree,
		SearchArea,
	},
	data() {
		return {
			splitValueL: 0.3,
			splitValueR: 0.7,
			//租户点击对象
			clickTenantObj: '',
			unitName: '',
		}
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
	},
	methods: {
		//新增点击
		addClick() {
			this.$refs.tenantTreeTable.doClick('add', '')
		},
		//租户点击
		tenantRowClick(row) {
			this.clickTenantObj = row
			this.$setSessionItem('currentRowDw', JSON.stringify(row))
			this.$refs.tenantUserTable.initTrans(row)
			// this.$refs.subjectTree.setBaseInfo(row)
		},
		//重置
		tenantSelectReset() {
			// this.$refs.subjectTree ? this.$refs.subjectTree.getSubject() : ''
			// this.$refs.subjectTree ? this.$refs.subjectTree.getTenantSubject('') : ''
		},

		// 筛选单位
		onFilter() {
			this.$refs.tenantTreeTable.filterUnit(this.unitName)
		},

		// 刷新筛选
		onRefresh() {
			this.$refs.tenantTreeTable.filterUnit('')
		},
	},
	beforeRouteLeave(to, from, next) {
		if (this.$getSessionItem('currentRowDw')) {
			this.$removeSessionItem('currentRowDw')
		}
		next()
	},
}
</script>
<style lang="less">
</style>